module.exports = "https://chowbus-web-static.chowbus.com/_next/static/images/chowbus_logo_text-9bdb929b78422fe1cafa343dc9203d12.png";